import { Injectable, inject } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize, tap } from 'rxjs/operators';
import { Environment, ENVIRONMENT_DI } from 'app/environment/environment';
import { toWidgetWrite } from './widget-write.model';
import { WidgetWriteTrackerService } from './widget-write-tracker.service';

@Injectable()
export class WidgetWriteInterceptor implements HttpInterceptor {
  private readonly tracker = inject(WidgetWriteTrackerService);
  private readonly gatewayUrl = inject<Environment>(ENVIRONMENT_DI).apiBaseUrls.gateway;

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const write = toWidgetWrite(request.method, request.url, this.gatewayUrl);
    if (!write) {
      return next.handle(request);
    }

    let succeeded = false;
    this.tracker.started(write);
    return next.handle(request).pipe(
      tap((event) => {
        if (event instanceof HttpResponse) {
          succeeded = true;
        }
      }),
      finalize(() => this.tracker.finished(write, succeeded)),
    );
  }
}
